// Only semantic floor planes can calibrate automatically. A horizontal table
// or an unlabeled hit is not sufficient evidence of a physical floor.
export function floorCandidate(plane, pose, headY) {
  const m = pose?.transform?.matrix;
  if (plane?.semanticLabel !== "floor" || plane.orientation !== "horizontal" || !m) return null;
  const y = m[13];
  if (!Number.isFinite(y) || !Number.isFinite(headY) || Math.abs(m[5]) < 0.94) return null;
  if (headY - y < 0.15 || headY - y > 2.8) return null;
  const vertices = Array.from(plane.polygon || []);
  let twiceArea = 0;
  for (let i = 0; i < vertices.length; i++) {
    const a = vertices[i], b = vertices[(i + 1) % vertices.length];
    twiceArea += a.x * b.z - b.x * a.z;
  }
  const area = Math.abs(twiceArea) / 2;
  return Number.isFinite(area) && area >= 0.25 ? { plane, y, area } : null;
}

export function createPhysicalFloorLock() {
  let pending = null, locked = null;
  return {
    reset() { pending = null; locked = null; },
    sample(candidate, time) {
      if (locked !== null) return locked;
      if (!candidate) { pending = null; return null; }
      if (!pending || pending.plane !== candidate.plane || Math.abs(pending.y - candidate.y) > 0.02 || time - pending.last > 250) {
        pending = { plane: candidate.plane, y: candidate.y, start: time, last: time, count: 1 };
        return null;
      }
      pending.last = time;
      pending.count++;
      if (time - pending.start >= 1000 && pending.count >= 10) locked = pending.y;
      return locked;
    },
  };
}
